import { motion } from "motion/react";

export default function Loading({ message }: { message?: string }) {
  const projectNameArray = () => {
    const name = "Kontrol";
    const nameArray = name.split("");
    return nameArray;
  };

  return (
    <div className="flex flex-col items-center justify-center">
      <div className="flex">
        {projectNameArray().map((letter, index) => (
          <motion.div
            key={index}
            className="text-2xl font-bold text-accent"
            initial={{ opacity: 0 }}
            animate={{ opacity: [0, 1, 0] }}
            transition={{
              duration: 2,
              repeat: Infinity,
              repeatType: "loop",
              delay: index * 0.1,
            }}
          >
            {letter}
          </motion.div>
        ))}
      </div>
      {message ? (
        <motion.div
          className="text-secondary text-md"
          animate={{ opacity: [1, 0, 1] }}
          transition={{
            duration: 2,
            repeat: Infinity,
            ease: "easeInOut",
          }}
        >
          {message}
        </motion.div>
      ) : null}
    </div>
  );
}
